import {
  ACCOUNT_MODAL,
  ACTION_PROCESSING,
  CREATE_SITE_MODAL,
  CUSTOM_DOMAIN_MODAL,
  EMAIL_SUBSCRIPTION_MODAL,
  PUBLISH_TO_CUSTOM_DOMAIN,
  CUSTOM_DOMAIN_DIAGNOSTICS,
  DRAGGED_FILE,
  SITE_TYPE,
  FETCHING_USER,
  HIDE_MESSAGE_MODAL,
  INSERT_USER_PROFILE,
  SET_ACTION,
  SET_API_KEY,
  SET_QRCODE_DATA,
  SHOW_FIRST_TIME_MODAL,
  SHOW_MESSAGE_MODAL,
  SHOW_QRCODE_MODAL,
  TOGGLE_MODAL,
  TOGGLE_TEAM_MODAL,
  TOGGLE_SELECT_TEAM_OWNER_MODAL,
  UPGRADE_MODAL,
  SET_EMBED_DATA,
  SET_PREVIEW_DATA,
  SHOW_PREVIEW_MODAL,
  TOGGLE_SIGNUP_MODAL,
  SET_LOADING_SITES_STORE,
  SET_LIVE_SITES_STORE,
  RESET_USER_PROFILE,
  SHOW_ACCOUNT_PASSWORD_MODAL,
  SAVE_FORM_VALUES,
  IS_PRESIGNED_UPLOAD_IN_PROGRESS,
  SHOW_DROPBOX_MODAL,
  FETCHING_SPACES,
  SET_SPACES,
  ADD_SPACE,
  UPDATE_SPACE,
  REMOVE_SPACE,
  SET_ACTIVE_SPACE,
  SHOW_CREATE_SPACE_MODAL,
  FETCHING_DELETED_SITES,
  INSERT_DELETED_SITES
} from '../Manage/actions'

import { ACTION_CREATE } from '../components/CreateUpdateSiteModal/interface'
import { PLANS_ID } from '../constants/plans'

const initState = {
  userProfile: {},
  archivedSites: [],
  deletedSites: [],
  fetchingDeletedSites: false,
  draggedFile: null,
  siteType: null,
  liveSites: [],
  newSiteData: {},
  QRCodeData: {},
  embedData: {},
  showQRCodeModal: false,
  previewData: undefined,
  showPreviewModal: false,
  showSignUpModal: false,
  showAccountPasswordModal: false,
  customDomains: [],
  accountModalVisible: false,
  dropboxModalVisible: false,
  showMessageModal: false,
  showFistTimeSuccModal: false,
  firstTimeSite: {},
  showSelectTeamOwnerModal: false,
  selectTeamOwnerData: [],
  customDomainModalVisible: false,
  customDomainModalData: null,
  modalEmailSubscriptionVisible: false,
  emailSubscriptionDomain: null,
  modalMessage: undefined,
  createSiteModal: {
    visible: false,
    data: {},
    action: ACTION_CREATE
  },
  displayModal: false,
  members: [],
  coupon: {
    isDiscount: false,
    percent_off: null
  },
  loadingSitesStore: [],
  githubData: {},
  // Spaces state
  spaces: [],
  fetchingSpaces: false,
  activeSpace: null, // null = 'All', 'archive' = Archive, or space ID
  showCreateSpaceModal: false
}

export default (state = initState, action) => {
  switch (action.type) {
    case INSERT_USER_PROFILE:
      const {
        userProfile,
        liveSites,
        hiddenLiveSitesCount,
        archivedSites,
        customDomains,
        members,
        apiKey,
        githubData,
        spaces,
        sso
      } = action.payload
      return {
        ...state,
        userProfile: {
          ...userProfile,
          ...(sso != null && userProfile?.sso == null ? { sso } : {}),
          apiKey: apiKey?.key,
          siteLimit: userProfile?.siteLimit || PLANS_ID[userProfile?.productId]?.projectLimit || 1
        },
        liveSites,
        hiddenLiveSitesCount: hiddenLiveSitesCount || 0,
        archivedSites,
        customDomains,
        members,
        githubData,
        spaces: spaces || []
      }
    case ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload
      }
    case FETCHING_USER:
      return {
        ...state,
        fetchingUser: action.payload
      }
    case ACCOUNT_MODAL:
      return {
        ...state,
        accountModalVisible: action.payload
      }
    case SHOW_DROPBOX_MODAL:
      return {
        ...state,
        dropboxModalVisible: action.payload
      }
    case UPGRADE_MODAL:
      return {
        ...state,
        upgradeModalVisible: action.payload
      }
    case TOGGLE_MODAL:
      return {
        ...state,
        displayModal: action.payload
      }
    case TOGGLE_TEAM_MODAL:
      return {
        ...state,
        showTeamModal: action.payload
      }
    case TOGGLE_SELECT_TEAM_OWNER_MODAL:
      return {
        ...state,
        showSelectTeamOwnerModal: action.payload.show,
        selectTeamOwnerData: action.payload.teamOwners || []
      }
    case SHOW_FIRST_TIME_MODAL:
      const { showFistTimeSuccModal, firstTimeSite } = action.payload
      return {
        ...state,
        showFistTimeSuccModal,
        firstTimeSite
      }
    case SHOW_MESSAGE_MODAL:
      return {
        ...state,
        modalMessageData: action.payload,
        showMessageModal: true
      }
    case HIDE_MESSAGE_MODAL:
      return {
        ...state,
        modalMessageData: undefined,
        showMessageModal: false
      }
    case SET_QRCODE_DATA:
      return {
        ...state,
        QRCodeData: action.payload
      }
    case SHOW_QRCODE_MODAL:
      return {
        ...state,
        showQRCodeModal: action.payload
      }

    case SET_EMBED_DATA:
      return {
        ...state,
        embedData: action.payload
      }
    case CUSTOM_DOMAIN_MODAL:
      return {
        ...state,
        customDomainModalVisible: action.payload?.show ?? action.payload,
        customDomainModalData: action.payload?.data ?? null
      }
    case EMAIL_SUBSCRIPTION_MODAL:
      return {
        ...state,
        modalEmailSubscriptionVisible: action.payload.show,
        emailSubscriptionDomain: action.payload.domain
      }
    case PUBLISH_TO_CUSTOM_DOMAIN:
      return {
        ...state,
        publishToCustomDomain: action.payload
      }
    case CUSTOM_DOMAIN_DIAGNOSTICS:
      // Todo: for custom domain diagnostics deep link
      return {
        ...state,
        DNSRecordsDiagnostics: action.payload
      }
    case DRAGGED_FILE:
      return {
        ...state,
        draggedFile: action.payload
      }
    case SITE_TYPE:
      return {
        ...state,
        siteType: action.payload
      }

    case CREATE_SITE_MODAL:
      return {
        ...state,
        createSiteModal: action.payload
      }

    case SET_API_KEY:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          apiKey: action.payload
        }
      }

    case SET_ACTION:
      return {
        ...state,
        createSiteModal: {
          ...state.createSiteModal,
          action: action.payload
        }
      }

    case SET_PREVIEW_DATA:
      return {
        ...state,
        previewData: action.payload
      }

    case SHOW_PREVIEW_MODAL:
      return {
        ...state,
        showPreviewModal: action.payload
      }

    case TOGGLE_SIGNUP_MODAL:
      return {
        ...state,
        showSignUpModal: action.payload
      }

    case RESET_USER_PROFILE:
      return {
        ...initState
      }

    case SET_LOADING_SITES_STORE:
      return {
        ...state,
        loadingSitesStore: action.payload
      }

    case SET_LIVE_SITES_STORE:
      return {
        ...state,
        liveSites: action.payload
      }

    case SHOW_ACCOUNT_PASSWORD_MODAL:
      return {
        ...state,
        showAccountPasswordModal: action.payload
      }

    case SAVE_FORM_VALUES:
      return {
        ...state,
        createSiteModal: {
          ...state.createSiteModal,
          savedFormValues: action.payload.formValues,
          savedInitValues: action.payload.initValues
        }
      }

    case IS_PRESIGNED_UPLOAD_IN_PROGRESS:
      return {
        ...state,
        isPresignedUploadInProgress: action.payload
      }

    case SHOW_DROPBOX_MODAL:
      return {
        ...state,
        dropboxModalVisible: action.payload
      }

    // Spaces reducer cases
    case FETCHING_SPACES:
      return {
        ...state,
        fetchingSpaces: action.payload
      }

    case SET_SPACES:
      return {
        ...state,
        spaces: action.payload
      }

    case ADD_SPACE:
      return {
        ...state,
        spaces: [...state.spaces, action.payload]
      }

    case UPDATE_SPACE:
      return {
        ...state,
        spaces: state.spaces.map((space) => (space.id === action.payload.id ? { ...space, ...action.payload } : space))
      }

    case REMOVE_SPACE:
      return {
        ...state,
        spaces: state.spaces.filter((space) => space.id !== action.payload),
        activeSpace: state.activeSpace === action.payload ? null : state.activeSpace
      }

    case SET_ACTIVE_SPACE:
      return {
        ...state,
        activeSpace: action.payload
      }

    case SHOW_CREATE_SPACE_MODAL:
      return {
        ...state,
        showCreateSpaceModal: action.payload
      }

    case FETCHING_DELETED_SITES:
      return {
        ...state,
        fetchingDeletedSites: action.payload
      }

    case INSERT_DELETED_SITES:
      return {
        ...state,
        deletedSites: action.payload
      }

    default:
      return state
  }
}
